import axios from "axios";
import { Url } from "src/config";

let pendingLeadershipBrandStatusPromiseMap = new Map();
let leadershipBrandStatusCacheMap = new Map();
let leadershipBrandStatusCacheTimestampMap = new Map();

const leadershipBrandApi ={
    getDashboardDat: async (accessToken, date,teamId) => {
        try {
            const params = {};
    
            if (date) {
                params.date = date;
            }
    
            const response = await axios.get(
                `${Url}/customer/dashboard/leadershipBrand?teamId=${teamId}`,
                {
                    headers: {
                        "access-token": accessToken,
                    },
                    params: params,
                }
            );
    
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
 getQuestionScores : async (accessToken,inviteduser,questionId,inviteid)=>{
    try {
        const response = await axios.get(`${Url}/customer/dashboard/leadershipBrandSurvey/getQuestionReports?invited_user_id=${inviteduser}&questions_id=${questionId}&inviteid=${inviteid}`,{headers:{
            "access-token": accessToken,
        },});
        return response.data
    } catch (error) {

        return error
    }
 },
 
 getLeadershipBrandStatus : async (accessToken,teamId) => {
    const cacheKey = `${teamId}`;
    const now = Date.now();

    if (leadershipBrandStatusCacheMap.has(cacheKey) && (now - (leadershipBrandStatusCacheTimestampMap.get(cacheKey) || 0) < 5000)) {
      return leadershipBrandStatusCacheMap.get(cacheKey);
    }
    if (pendingLeadershipBrandStatusPromiseMap.has(cacheKey)) {
      return pendingLeadershipBrandStatusPromiseMap.get(cacheKey);
    }

    const promise = (async () => {
      try {
        const response = await axios.get(`${Url}/customer/dashboard/getleadershipBrandStatus?teamId=${teamId}`,{headers:{
            "access-token": accessToken,
        },});
        leadershipBrandStatusCacheMap.set(cacheKey, response.data);
        leadershipBrandStatusCacheTimestampMap.set(cacheKey, Date.now());
        return response.data;
      } catch (error) {
        return error;
      } finally {
        pendingLeadershipBrandStatusPromiseMap.delete(cacheKey);
      }
    })();

    pendingLeadershipBrandStatusPromiseMap.set(cacheKey, promise);
    return promise;
 }
}
export default leadershipBrandApi;
